/**
 * Which groups a member sees in their group list, from the groups in scope
 * and the group ids of their own groupMembers rows (namat#36 P2: the
 * navigation unread total counts exactly these).
 *
 * Mirrors GroupList: a regular group counts when the member belongs to it; a
 * section (groupType 'parent') counts when they belong to one of its child
 * groups in the same organization (virtual membership). A section with only
 * one such child is hidden in favour of that child.
 */
export interface GroupScopeLike {
  id: string;
  groupType?: string;
  parentGroupId?: string | null;
  organization?: string | null;
}

export function selectMyGroupIds(
  groups: readonly GroupScopeLike[],
  memberGroupIds: Iterable<string>,
): string[] {
  const member = new Set(memberGroupIds);
  const byId = new Map(groups.map((g) => [g.id, g]));

  const isMember = (g: GroupScopeLike): boolean => {
    if (g.groupType !== 'parent') return member.has(g.id);
    return groups.some(
      (child) =>
        child.parentGroupId === g.id &&
        child.organization === g.organization &&
        member.has(child.id),
    );
  };

  const mine = groups.filter(isMember);
  const memberChildren = new Map<string, number>();
  for (const g of mine) {
    if (g.parentGroupId && byId.has(g.parentGroupId)) {
      memberChildren.set(g.parentGroupId, (memberChildren.get(g.parentGroupId) ?? 0) + 1);
    }
  }
  return mine
    .filter((g) => !(g.groupType === 'parent' && memberChildren.get(g.id) === 1))
    .map((g) => g.id);
}
